import {ButtonNavLink} from '@components/commons/button-nav-link'
import {useTranslation, APP_LANGUAGES} from '@/translations/i18n.tsx'
import {Globe02Icon} from '@components/ui/icon'
import {FC, useState} from 'react'
import {LangSelectionModal} from '@components/commons/lang-selection-modal'
import {Button} from '@components/ui/button'
import {Container} from '@components/ui/container'
import {Link} from 'react-router-dom'
import {routes} from '@utilities/constants/routes.tsx'
import {UserDropdown} from '@components/commons/user-dropdown'
import {useMe} from '@features/user/queries/useMe.ts'
import {MobileMenu} from '@components/commons/mobile-menu'
import {raise} from '@utilities/helpers.ts'
import icon from '/favicon1.svg'
import {Badge} from '@components/ui/badge'
import {useAuthStore} from '@features/user/store/store'
import {useMediaQuery} from '@hooks/use-media-query'

export const Header: FC<{isPrivate: boolean}> = ({isPrivate}) => {
    const {
        t,
        i18n: {language}
    } = useTranslation()

    const isLarge = useMediaQuery({breakpoint: 'md'})
    const [showLangModal, setShowLangModal] = useState(false)
    const meQuery = useMe({enabled: isPrivate})
    const adminAccessToken = useAuthStore(state => state.adminAccessToken)

    if (isLarge) {
        return (
            <div className="h-16 border-b border-neutral-200 bg-white">
                <Container className="flex h-full items-center justify-between gap-8">
                    <div className="flex items-center gap-4">
                        <Link to={routes.HOME.handle.fullPath} className="flex cursor-pointer">
                            <img src={icon} alt={'icon'} />
                        </Link>
                        {isPrivate && (
                            <div className="flex items-center gap-1">
                                <ButtonNavLink to={routes.HOME.handle.fullPath} variant="ghost">
                                    {t('home:title')}
                                </ButtonNavLink>
                                <ButtonNavLink to={routes.PAYMENTS.handle.fullPath} variant="ghost">
                                    {t('admin:payments:title')}
                                </ButtonNavLink>
                                {/* TODO: remove Badge and disabled this when we have the feature @InsightsPage */}
                                {adminAccessToken || meQuery.data?.isInsightsVisible ? (
                                    <ButtonNavLink to={routes.INSIGHTS.handle.fullPath} variant="ghost">
                                        {t('insights:title')}
                                    </ButtonNavLink>
                                ) : (
                                    <ButtonNavLink to={routes.INSIGHTS.handle.fullPath} variant="ghost" disabled>
                                        {t('insights:title')}

                                        <Badge variant="blue">
                                            {t('settings:personal_information:coming_soon_calendar_text_small')}
                                        </Badge>
                                    </ButtonNavLink>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="flex items-center gap-1">
                        {/* <ButtonLink to={TUTORIAL_LINK} target="_blank" variant="ghost">
                    <YoutubeIcon />
                    {t('menu:video_walkthrough')}
                </ButtonLink>*/}
                        <Button variant="ghost" onClick={() => setShowLangModal(true)}>
                            <Globe02Icon />
                            {APP_LANGUAGES.find(lang => lang.code == language)?.label}
                        </Button>
                        {isPrivate && <UserDropdown />}
                    </div>
                </Container>
                {showLangModal && <LangSelectionModal onCloseCb={() => setShowLangModal(false)} />}
            </div>
        )
    }

    return (
        <div className="h-16 border-b border-neutral-200 bg-white">
            <Container className="flex h-full items-center justify-between gap-8">
                <Link to={routes.HOME.handle.fullPath} className="flex cursor-pointer">
                    <img src={icon} alt={'icon'} />
                </Link>
                {isPrivate ? (
                    <MobileMenu user={meQuery.data ?? raise('user is nullish')} adminAccessToken={adminAccessToken} />
                ) : (
                    <div className="flex items-center gap-1">
                        {/* <ButtonLink to={TUTORIAL_LINK} target="_blank" variant="ghost" shape="square">
                                <YoutubeIcon />
                            </ButtonLink>*/}
                        <Button variant="ghost" onClick={() => setShowLangModal(true)}>
                            <Globe02Icon />
                            {APP_LANGUAGES.find(lang => lang.code == language)?.label}
                        </Button>
                    </div>
                )}
            </Container>
            {showLangModal && <LangSelectionModal onCloseCb={() => setShowLangModal(false)} />}
        </div>
    )
}
